import { render, staticRenderFns } from "./OverviewRotator.vue?vue&type=template&id=2cabd50a&scoped=true"
import script from "./OverviewRotator.vue?vue&type=script&lang=js"
export * from "./OverviewRotator.vue?vue&type=script&lang=js"
import style0 from "./OverviewRotator.vue?vue&type=style&index=0&id=2cabd50a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cabd50a",
  null
  
)

export default component.exports